import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleProfessionalReport } from 'domain/usecases';

interface IProfessionalReport {
  data: HandleProfessionalReport.Result[];
}

interface IPayloadData
  extends PayloadAction<HandleProfessionalReport.Result[]> {}

const initialState: IProfessionalReport = {
  data: null,
};

export const ProfessionalReportSlice = createSlice({
  name: 'professional-report',
  initialState,
  reducers: {
    loadProfessionalReport: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    clearProfessional: (state) => {
      state.data = null;
    },
  },
});

export const { loadProfessionalReport, clearProfessional } =
  ProfessionalReportSlice.actions;

export default ProfessionalReportSlice.reducer;
